import React from 'react'
import {connect} from 'react-redux'

class GroupChatsLists extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      activeSection: props.activeSection
    }
  }

  componentWillMount () {
    this.setState({activeSection: this.props.activeSection})
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.activeSection !== nextProps.activeSection) {
      this.setState({activeSection: this.props.activeSection})
    }
  }

  changeToSection (section, e) {
    if (e && e.preventDefault) e.preventDefault()

    if (this.state.activeSection !== section) this.setState({activeSection: section})
  }

  renderSectionsTabButtons () {
    return this.props.sections.map((section, index) => {
      if (typeof(section.isActive) === 'function' && !section.isActive()) return false
      if (section.isActive === false) return false

      return (
        <button
          key={index}
          className={this.state.activeSection === index ? 'active' : ''}
          onClick={this.changeToSection.bind(this, index)}>
          {section.label}
        </button>
      )
    })
  }

  renderSectionsTab () {
    return (
      <div style={{textAlign: 'center', paddingBottom: 10}}>
        <div className='button-group large success'>
          {this.renderSectionsTabButtons()}
        </div>
      </div>
    )
  }

  renderActiveSection () {
    return this.props.sections[this.state.activeSection].Content
  }

  render () {
    return (
      <div className='group-chats-lists'>
        {this.renderSectionsTab()}
        {this.renderActiveSection()}
      </div>
    )
  }
}

GroupChatsLists.defaultProps = {
  activeSection: 0,
  sections: []
}

const mapStateToProps = () => {
  return {
  }
}

const mapDispatchToProps = () => {
  return {
  }
}

const GroupChatsListsContainer = connect(
  mapStateToProps, mapDispatchToProps
)(GroupChatsLists)

export default GroupChatsListsContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/group_chats_lists.js
 **/